const buildLocalKey = (key) => key?.startsWith('su-') ? key : `su-${key}`;

export const getKeyForBlob = (key) => key?.startsWith('su-') ? key.slice(3) : key;

export const regexKey = /^su-[-0-9a-f]+/;

export const saveLocalValues = (key, values) => {
	localStorage.setItem(buildLocalKey(key), JSON.stringify({
		...getLocalValue(key),
		...values,
	}));
}

export const getLocalValue = (key) => JSON.parse(localStorage.getItem(buildLocalKey(key)));

export const removeLocalValue = (key) => localStorage.removeItem(buildLocalKey(key));

export const findLocalStorageValues = (regex) => {
	const keys = Object.keys(localStorage);
	return keys.filter((key) => regex.test(key));
}

export const cleanStorageInformation = () => {
	const localValues = findLocalStorageValues(/^su-[-0-9a-f]+/);
	localValues.forEach((key) => localStorage.removeItem(key));
}

/*
* Localstorage methods for participations used only when user id not connected
*/

export const findParticipation = (solutionId, participationMeta) => {
	const localStorageValues = localStorage.getItem('participations');
	if (!localStorageValues) {
		return null;
	}

	const meta = typeof participationMeta === 'string' ? JSON.parse(participationMeta) : participationMeta;
	const sortedParticipations = JSON.parse(localStorageValues)
		.sort((a, b) => b.createdAt - a.createdAt);

	return meta?.PRODUCT_ID
		? sortedParticipations.find((participation) => {
			const parsedMeta = participation.meta && typeof participation.meta === 'string' ? JSON.parse(participation.meta) : participation.meta;

			return parsedMeta?.PRODUCT_ID === meta.PRODUCT_ID && participation.solutionId === solutionId;
		})
		: sortedParticipations.find((participation) => participation.solutionId === solutionId);
}

export const saveParticipation = (participation, solutionId) => {
	const localStorageValues = localStorage.getItem('participations');
	const parsedValues = localStorageValues ? JSON.parse(localStorageValues) : [];

	localStorage.setItem('participations', JSON.stringify([
		...parsedValues,
		{
        	...participation,
        	solutionId,
		},
	]));
}

export const updateParticipation = (participation) => {
  const localStorageValues = localStorage.getItem('participations');
  const parsedValues = localStorageValues ? JSON.parse(localStorageValues) : [];

  localStorage.setItem(
    'participations',
    JSON.stringify(
      parsedValues.map((localParticipation) => (localParticipation.id === participation.id ? ({ ...localParticipation, ...participation }) : localParticipation))
    )
  );
}
